import type { IconSvgObject } from './types';

const JoinRoundIcon: IconSvgObject = [
  ["path", { d: "M21.9998 13V22H11.9998C6.47698 22 1.99983 17.5228 1.99983 12V2H10.9998V11C10.9998 12.1046 11.8953 13 12.9998 13H21.9998Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default JoinRoundIcon;
